// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__W82AL","header":"Messages_header__OTpwg"};